import { useState } from "react";
import { UserPlus } from "lucide-react";
import { CreatePersonalOrgDialog } from "./CreatePersonalOrgDialog";

type Props = {
  initialName?: string;
  initialPhone?: string;
};

/** Mostrado só pra quem nunca ganhou organização pessoal — hoje só acontece com quem entrou via
 *  convite de equipe (auth.signup já marca onboardingCompletedAt na hora, sem passar pelo wizard,
 *  então essa pessoa nunca cria a própria organização automaticamente). */
export function CreatePersonalOrgSection({ initialName, initialPhone }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <section className="rounded-2xl border border-zinc-100 bg-white p-6 shadow-sm dark:border-border dark:bg-card sm:p-8">
      <h2 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Conta pessoal</h2>
      <p className="mt-1 text-[12.5px] text-zinc-500 dark:text-muted-foreground">
        Você entrou direto numa organização de equipe e ainda não tem uma organização pessoal — um
        espaço só seu, independente de quem te convidou.
      </p>

      <button
        type="button"
        onClick={() => setOpen(true)}
        className="mt-4 inline-flex h-9 items-center gap-1.5 rounded-md bg-brand-600 px-4 text-[12.5px] font-semibold text-white shadow-sm transition-colors hover:bg-brand-700"
      >
        <UserPlus className="h-3.5 w-3.5" />
        Criar minha conta pessoal
      </button>

      <CreatePersonalOrgDialog
        open={open}
        onOpenChange={setOpen}
        initialName={initialName}
        initialPhone={initialPhone}
      />
    </section>
  );
}
